var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditAgricole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 248.3 48.1",
    style: {
      enableBackground: "new 0 0 248.3 48.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00664B;}\n\t.st1{fill:#008B92;}\n\t.st2{fill:#E2231A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 42.3,
    className: "st0",
    width: 60.8,
    height: 5.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.3,12.7L43.4,23l7.2-3.8L44.4,5.3h-9.1L22.4,29.2c0,0,6.3-0.2,10.3-3.2C33.8,25.4,36.7,17.8,39.3,12.7 L39.3,12.7L39.3,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.7,19.2L43.4,23c-6.2,3.2-12.1,6-15.3,6.9c-8.4,2.4-18.6,3.9-22.2,0.6c-3.4-3.1,4.5-15.9,19.5-18.7 c2.4-0.5,3.9-0.4,3.9-0.4c0,0-1-4.4-1.8-5.3c-1.1-1.4-2.2-1.7-3.9-1.4C20.4,4.8,6.6,8.5,1.1,20.1c-3,6.6,1,13.2,3.6,15.1 c1.2,0.9,9.1,7.9,27.3,0.8c17.9-7,34-17.9,34-17.9v-7.3C65.9,10.7,58.9,14.8,50.7,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,29.7c0.7,1.6,2.6,6.2,3.1,7.5c0.6,1.4,2.2,1.4,2.2,1.4h8.4l-6.2-12.9C51.1,27,48.6,28.3,46,29.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66,7.9c0,0-9.6,5.5-11.8,6.3c-2.1,0.8-2.8-0.3-3.1-0.6c-0.6-0.8-1.5-3.6-1.6-4c0.1,0,0.6,0.1,1.8-0.2 C52.8,9,65.9,1.6,66,1.6V7.9L66,7.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.1,5c2.9,0,5.8,0.9,8.3,2.6l-1.9,2.4c-2-1.4-3.6-2.1-6.2-2.1c-4.4,0-7.8,2.7-7.8,6.7c0,4,3.4,6.7,7.8,6.7 c2.6,0,4.4-0.8,6.5-2.2l1.9,2.4c-2.5,1.8-5.6,2.7-8.6,2.7c-6,0-11.7-3.5-11.7-9.6C82.4,8.5,88.1,5,94.1,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.6,5.3h10c4.7,0,8.4,1.9,8.4,5.9c0,3.2-2.3,4.8-5.5,5.6l6.1,7H121l-5.5-6.5h-4.9v6.5h-4V5.3z M116.3,14.5 c2.8,0,4.6-1.2,4.6-3.2c0-2-1.7-3-4.6-3h-5.7v6.2H116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.4,18.5V5.3h16.8v3h-12.8v4.5h11.7v2.9h-11.7v2.9c0,1.6,0.8,2.4,2.3,2.4h10.8v3h-11.8 C131.4,23.8,129.4,21.8,129.4,18.5z M142.2,0l-3.1,3.3h-3.4l2.3-3.3H142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.3,5.3h8.4c7.1,0,11.9,3.7,11.9,9.3s-4.8,9.3-11.9,9.3h-8.4V5.3z M159.9,20.8c4.5,0,7.5-2.5,7.5-6.3 c0-3.8-3-6.3-7.5-6.3h-4.7v12.6H159.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.8,5.3h4v18.5h-4V5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.7,8.3v-3h18.2v3h-7.1v15.5h-4V8.3H183.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.3,43.3H88.1l-2.2,4.5h-4l9.6-18.5h4l9.6,18.5h-4.5L98.3,43.3z M96.9,40.4l-3.6-7.4l-3.6,7.4H96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.9,28.9c2.9,0,5.8,0.9,8.3,2.6l-1.9,2.4c-2-1.4-3.6-2.1-6.2-2.1c-4.4,0-7.8,2.7-7.8,6.6 c0,3.9,3,6.7,7.6,6.7c2,0,3.9-0.6,5.2-1.4v-3.5h-5.6v-2.8h9.5v7.8c-2.2,1.6-5.4,2.9-9.4,2.9c-7,0-11.6-4.1-11.6-9.6 C106.3,32.4,111.9,28.9,117.9,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.3,29.3h10c4.7,0,8.4,1.9,8.4,5.9c0,3.2-2.3,4.8-5.5,5.6l6.1,7h-4.6l-5.5-6.5h-4.9v6.5h-4V29.3z M142,38.4 c2.8,0,4.6-1.2,4.6-3.2c0-2-1.7-3-4.6-3h-5.7v6.2H142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.8,29.3h4v18.5h-4V29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.9,28.9c2.9,0,5.8,0.9,8.3,2.6l-1.9,2.4c-2-1.4-3.6-2.1-6.2-2.1c-4.4,0-7.8,2.7-7.8,6.7s3.4,6.7,7.8,6.7 c2.6,0,4.4-0.8,6.5-2.2l1.9,2.4c-2.5,1.8-5.6,2.7-8.6,2.7c-6,0-11.7-3.5-11.7-9.6C164.2,32.4,169.9,28.9,175.9,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.9,38.5c0-5.2,4.9-9.6,11.7-9.6c6.8,0,11.7,4.3,11.7,9.6c0,5.2-4.9,9.6-11.7,9.6 C190.8,48.1,185.9,43.7,185.9,38.5z M190,38.5c0,3.7,3.1,6.7,7.6,6.7c4.5,0,7.6-3,7.6-6.7s-3.1-6.7-7.6-6.7 C193.1,31.8,190,34.8,190,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213,29.3h4v15.5h11.8v3H213V29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.2,42.4V29.3H248v3h-12.8v4.5h11.7v2.9h-11.7v2.9c0,1.6,0.8,2.4,2.3,2.4h10.8v3h-11.8 C233.2,47.8,231.2,45.8,231.2,42.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditAgricole);
export default __webpack_public_path__ + "static/media/credit-agricole.62dc9ad139ae521c3e8a2fa2227479c7.svg";
export { ForwardRef as ReactComponent };